import {AppCard} from '@/features/apps/shared/models/appCard';

export class HomescreenAppInitViewModel {
	public id: string;
	public card: AppCard;
}
